import { http } from '@/api/httpAxios'
import { AxiosPromise } from 'axios'

export default class ProfileAPI {
  public static updateProfile(data: any): AxiosPromise {
    return http.put('/users/profile', data)
  }

  public static updateMyAuthors(): AxiosPromise {
    return http.get('/users/profile/update-my-authors')
  }
}
